<template>
	<div id="intent">
		<div class="container-fluid">
			<!-- <a href="javascript:void(0);" class="btn btn-primary" v-if="!isShow" @click="isShow = true" v-scroll-to="'#add_new_intent'" style="position: fixed; right: 15px; bottom: 15px;font-size: 20px;z-index: 100"><i class="fa fa-plus middle"></i> Add</a> -->
			<h3 class="title">Intents <modal-help link="https://blog.zwiz.ai/zwiz-ai-auto-reply#convesation"  v-if="!$store.state.theme.hide_zwiz"></modal-help></h3>
			<div class="row" v-if="intents.length > 0" style="margin-bottom:15px;">
				<div class="col-sm-6">
					<input type="text" v-model="search" class="form-control" placeholder="Search Intent Name" style="margin-bottom: 10px">
				</div>
				<div class="col-sm-6 text-right" >
					<a href="javascript:void(0);" style="margin-bottom: 5px;" class="btn btn-gray transparent" @click="expandAll"><i class="fas fa-expand-arrows-alt"></i> Expand All</a>
					<a href="javascript:void(0);" style="margin-bottom: 5px;" class="btn btn-gray transparent" @click="collapseAll"><i class="fas fa-compress"></i> Collapse All</a>
					<a href="javascript:void(0);" style="margin-bottom: 5px;" class="btn btn-primary" v-if="!isShow" @click="isShow = true" v-scroll-to="'#add_new_intent'"><i class="fa fa-plus middle"></i> Add</a>
				</div>
			</div>

			<div id="add_new_intent"></div>
			<div class="alert alert-success alert-dismissible" role="alert" v-if="isSave">
				<button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="isSave = false"><span aria-hidden="true">&times;</span></button>
				<strong>Success!</strong> Intent "{{lastedIntentName}}" added
			</div>
			<div  class="intent-item edit" v-if="isShow">
				<div class="container-fluid">
					<div>
						<a href="javascript:void(0);" >
						<div class="header row" >
							<div class="col-xs-10" >
								
								<span style="margin-right:5px;margin-bottom: 10px;">Add Intent</span>
							</div>
						</div>
						</a>
						<div   style="border-top:1px solid #eee;padding-top:15px;padding-bottom:15px;background: white;">
								<div class="row">
									<div class="col-xs-12">
										<manage-intent :type="'add'" v-model="intent" @close="onClose"  @saveIntent="onSaveIntent" :excludedIntentName="excludedIntentName"></manage-intent>
									</div>
								</div>
						</div>

					</div>
				</div>
			</div>
			
			
		</div>
		<div>
			<div style="overflow-x: hidden; overflow-y: auto;padding: 15px 25px;border-top: 1px solid #eee;" v-if="intents.length > 0">
				<div class="row" >
					<intent-item v-for="(item,index) in filterIntents" :key="'intent_' + item.id + '_' + index" v-model="filterIntents[index]" @onDelete="deleteIntent(index)" @onCopyIntent="copyIntent"  :excludedIntentName="excludedIntentName" @onUpdate="onUpdateIntent"></intent-item>
					<hr>
					<intent-item v-model="default_intent" :welcomemessage="welcome_message" ></intent-item>
				</div>
			</div>
			<div class="text-center container-fluid" style="margin: 35px 0" v-else>
				<img src="/static/img/assets/setting/conversation.png" alt="" style="width: 230px">
				<h3>Create your first conversation</h3>
				<p>Click "Add Conversation" to communicate with your customer</p>
				<a href="javascript:void(0);" class="btn btn-primary" @click="isShow = true"><i class="fa fa-plus middle"></i> Add New Conversation</a>
			</div>
			
		</div>
			
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import manageIntent from './intent-manage';
import intentItem from './intent-item';
import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalHelp from '@/components/elements/ModalHelp'
	export default{
		components: {
			'manage-intent' : manageIntent,
			'intent-item' : intentItem,
			ModalDialog,
			ModalHelp
		},
		data() {
			return {
				isShow: false,
				showModal: false,

				intent: {
					intentname: '',
					q_type: 'text',
					a_type : 'text',
					q_val: '',
					a_val: '',
					context_in: '',
					context_out: ''
				},
				intents : [],
				search: '',
				welcome_message: {
					message: '',
					generics: [],
					type: '',
					quick_reply: []
				},
				isSave: false,
				lastedIntentName: '',
				default_intent: undefined
			};
		},
		computed: {
		    ...mapGetters({
		        selectedBot: 'selectedBot'
		    }),
			filterIntents: function(){
				var vm = this
				vm.intents.sort(function(a, b) {
					var nameA = a.intentname.toUpperCase(); // ignore upper and lowercase
					var nameB = b.intentname.toUpperCase(); // ignore upper and lowercase
					if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
						return 1;
					}
					if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
						return -1;
					}
					if (nameA < nameB) {
						return -1;
					}
					if (nameA > nameB) {
						return 1;
					}

					// names must be equal
					return 0;
				});

				return vm.intents.filter(intent => {
					var isFound = intent.intentname.toLowerCase().includes(vm.search.toLowerCase()) ||
						intent.q_val.toLowerCase().includes(vm.search.toLowerCase()) ||
						intent.a_val.toLowerCase().includes(vm.search.toLowerCase())
					return isFound
				})
			},
			excludedIntentName: function(){
				var result = []
				var vm = this
				$.each(vm.intents,function(index, intent){
					result.push(intent.intentname)
				})
				return result.join(',')
			}
		},
		mounted: function(){
			var vm = this

			vm.$store.dispatch('loading')
			vm.getWelcomeMessage(function(){

				vm.getIntent(function(){

					vm.$store.dispatch('loading')
				})
			})
		},
		methods: {
			onSaveIntent: function(payload){
				// console.log(payload)
				var vm  =this
				vm.isShow = false
				payload.isShow = true
				vm.intents.push(payload)
				vm.intent = {
					intentname: '',
					q_type: 'text',
					a_type : 'text',
					q_val: '',
					a_val: '',
					context_in: '',
					context_out: ''
				}
				vm.lastedIntentName = payload.intentname
				vm.isSave = true
				$("html, body").animate({ scrollTop: 0 });
				setTimeout(() => {
					vm.isSave = false
				}, 10000);
			},
			copyIntent: function(payload){
				payload.isShow = true
				this.intents.push(payload)
				$("html, body").animate({ scrollTop: $(document).height()-$(window).height() });
			},
			onClose: function(payload){
				this.isShow = false
				// this.intents.push(payload)
				// this.getIntent()
			},
			getIntent: function(callback) {
				let vm = this
				let auth = null;
				let data = {
					pageid : vm.selectedBot.pageid,
				}
				api.getIntent(data,function(error, response){
					if (error) {
						console.error(error)
						return
					}
					if (response.data) {
						var isFoundDefault = false
						$.each(response.data,function(index, val){
							var intent = val
							intent.isShow = false
							intent.ableToDelete = true
							if (intent.intentname == '{default}') {
								intent.ableToDelete = false
								isFoundDefault = true
								vm.default_intent = intent
							} else {
								vm.intents.push(intent)
							}
						})

						if (!isFoundDefault) {
							vm.default_intent = {
								intentname: '{default}',
								q_type: 'text',
								a_type : 'none',
								q_val: '',
								a_val: '',
								context_in: '',
								context_out: '',
								ableToDelete: false,
								isShow: false
							}
						}
					}
					callback()
				})
			},
			deleteIntent: function(index){
				let vm = this
				if (confirm("Do you want to delete this")) {
					let data = {
						id : vm.filterIntents[index].id,
						pageid : vm.selectedBot.pageid
					}
					vm.$store.dispatch('loading')
					api.deleteIntent(data,function(error, response){
						if (error) {
							console.error(error)
							vm.$store.dispatch('loading')
							return
						}
						
						$.each(vm.intents,function(intent_index, intent){
							if (intent.id == data.id) {
								vm.intents.splice(intent_index,1)
								return false
							}
						})
						vm.$store.dispatch('loading')
					})
				}
			},
			getWelcomeMessage: function(callback){
				let vm = this
				let data = {
					'pageid' : vm.selectedBot.pageid
				};

				vm.welcome_message.message = null
				vm.welcome_message.generics = [
					{
						image_url: null,
						title: '',
						subtitle: '',
						buttons: [],

						enable: true
					},
					{
						image_url: null,
						title: '',
						subtitle: '',
						buttons: [],

						enable: false
					},
					{
						image_url: null,
						title: '',
						subtitle: '',
						buttons: [],

						enable: false
					},

				]
				vm.welcome_message.type = 'message'
				api.getWelcomeMessage(data,function(error, response){
					if (error) {
						console.error(error)
						return
					}
					if (response.data) {
						vm.welcome_message.type = response.data.type
						vm.welcome_message.message = response.data.message_text ? response.data.message_text : ''
						
						if (response.data.message && typeof response.data.message === 'object' && response.data.message.length > 0) {
							$.each(response.data.message,function(index,val){
								vm.welcome_message.generics[index] = val
							})
						}

						if (response.data.message_quickreplies && response.data.message_quickreplies != "" && response.data.message_quickreplies != null) {
							vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
						} else {
							vm.welcome_message.quick_reply = []
						}

					}
					callback()
				})
			},
			expandAll: function(){
				var vm = this
				$.each(vm.intents,function(index, intent){
					vm.intents[index].isShow = true
				})
				vm.default_intent.isShow = true
			},
			collapseAll: function(){
				var vm = this
				$.each(vm.intents,function(index, intent){
					vm.intents[index].isShow = false
				})
				vm.default_intent.isShow = false
			},
			onUpdateIntent: function(payload){
				var vm = this
				$.each(vm.intents,function(index, intent){
					if (intent.id == payload.id) {
						vm.intents[index] = payload
						return false
					}
				})
			}
		},
		watch: {
			selectedBot: function( newVal , oldVal){
				this.getIntent(function(){

				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/view/intent/Intent.vue